import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import QuickStartPage from "../pages/quick-start/page";
import InstallationPage from "../pages/installation/page";
import ChannelsPage from "../pages/channels/page";
import SkillsPage from "../pages/skills/page";
import AgentsPage from "../pages/agents/page";
import ToolsPage from "../pages/tools/page";
import GatewayPage from "../pages/gateway/page";
import ReferencePage from "../pages/reference/page";
import HelpPage from "../pages/help/page";
import CasesPage from "../pages/cases/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/quick-start",
    element: <QuickStartPage />,
  },
  {
    path: "/installation",
    element: <InstallationPage />,
  },
  {
    path: "/channels",
    element: <ChannelsPage />,
  },
  {
    path: "/skills",
    element: <SkillsPage />,
  },
  {
    path: "/agents",
    element: <AgentsPage />,
  },
  {
    path: "/tools",
    element: <ToolsPage />,
  },
  {
    path: "/gateway",
    element: <GatewayPage />,
  },
  {
    path: "/models",
    element: <CasesPage />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/reference",
    element: <ReferencePage />,
  },
  {
    path: "/help",
    element: <HelpPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;